/** Syncs store theme to document.documentElement and localStorage. */
import { useEffect } from "react";
import { useAppStore } from "../../store";

function applyTheme(theme: "light" | "dark") {
  const root = document.documentElement;
  if (theme === "dark") {
    root.classList.add("dark");
  } else {
    root.classList.remove("dark");
  }
  localStorage.setItem("theme", theme);
}

export function ThemeSync() {
  useEffect(() => {
    applyTheme(useAppStore.getState().theme);
    const unsub = useAppStore.subscribe((state) => applyTheme(state.theme));
    return unsub;
  }, []);
  return null;
}
